import React from 'react';
import './Login.css';
import AuthService from '../Helpers/AuthService';


export default class Login extends React.Component  {
    constructor(){
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.Auth = new AuthService();
        this.state={username: null, password:null}
    }

componentWillMount(){
    if(this.Auth.loggedIn()){
        console.log(this.Auth.loggedIn())

        this.props.history.replace('/');
    }
}

 handleFormSubmit(e){
        e.preventDefault();   
        if(this.state.username !== null && this.state.password !== null){
        this.Auth.login(this.state.username,this.state.password)
            .then(res =>{
               this.props.history.replace('/');
            })
            .catch(err =>{
               alert("Pogresna Šifra ili korisničko ime!")
            })
        }else{

        }
    }

        handleChange(e){
        this.setState(
            {
                [e.target.name]: e.target.value
            }
        )
    }


    render() {
        return (
            <div style={{overFlow:'hidden'}}>
            <div className="center">
                <div className="card">
                    <h1>Prijava</h1>
                    <form onSubmit={this.handleFormSubmit}>
                        <input
                            className="form-item"
                            placeholder="Korisničko ime..."
                            name="username"
                            type="text"
                            onChange={this.handleChange}
                        />
                        <input
                            className="form-item"
                            placeholder="Šifra..."
                            name="password"
                            type="password"
                            onChange={this.handleChange}
                        />
                        <input
                            className="form-submit"
                            value="Prijavi me"
                            type="submit"
                        />
                    </form>
                </div>
            </div></div>
        );
    }


}



// WEBPACK FOOTER //
// ./src/Moduli/Login.js